import 'react-image-crop/dist/ReactCrop.css';
import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import ReactImageCrop from 'react-image-crop';
import { injectIntl } from 'react-intl';
import locale from '../../../routes/create/locale';

const ImageCropper = props => (
  <Modal open={props.modalOpen} centered size="small">
    <Modal.Content style={{ textAlign: 'center' }}>
      <ReactImageCrop
        src={props.resizedImage}
        crop={props.cropSelector}
        onChange={props.onHandleCropSelector}
        onImageLoaded={props.onImageLoaded}
      />
      <div style={{ paddingTop: '1.5rem', textAlign: 'right' }}>
        <Button primary inverted style={{ marginRight: '1rem' }} onClick={props.onHandleClose}>
          {props.intl.formatMessage(locale.cancelButton)}
        </Button>
        <Button primary style={{ margin: '0' }} onClick={props.onHandleCrop}>
          {props.intl.formatMessage(locale.cropButton)}
        </Button>
      </div>
    </Modal.Content>
  </Modal>
);

export default injectIntl(ImageCropper);
